import {
  buildRelevanceSortCriterion,
  buildFieldSortCriterion,
  SortOrder,
  SortByRelevancy,
  SortByField
} from '@coveo/headless';

const SORT_ORDER = Object.freeze({
  ascending: SortOrder.Ascending,
  descending: SortOrder.Descending
});

export type SortFields = {
  title: string;
  field: string;
  type: string;
  direction: string;
  context?: {
    [key: string]: string;
  };
};

export type SortCriteria = {
  title: string;
  criterion: SortByRelevancy | SortByField | null;
};

const { dataset } = document.getElementsByClassName(
  'coveo-listing__data-wrapper'
)[0] as HTMLElement;

let fields = [];

if (dataset.sortFields) {
  fields = JSON.parse(dataset.sortFields);
}

export const sortFields = fields.map((field: SortFields) => {
  const obj = {
    title: field.title,
    criterion: null,
    context: field.context
  } as SortCriteria;

  if (field.type === 'relevance') {
    obj.criterion = buildRelevanceSortCriterion();
  }

  if (field.type === 'field') {
    obj.criterion = buildFieldSortCriterion(
      field.field,
      SORT_ORDER[field.direction as keyof typeof SORT_ORDER]
    );
  }

  return obj;
});
